const {KitModule, registerModule} = window;

const TOGGLE_SUBNAV_KEYS = [
  ' ',
  'Enter', // enter already works on links, but needed here so it also works in hover mode
];

const CLOSE_SUBNAV_KEYS = [
  'Escape',
];

class Nav extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.positionSubnavs();
    this.reset();
  }

  setVars() {
    // this.$menu set in html
    // this.$primary set in html
    // this.$back set in html
    // this.$toggles set in html
    // this.$subLists set in html
    // this.$indicator set in html

    this.$pageSections = document.querySelectorAll(
      '#main > section, #main > .postListing > *, #main > .post, #footer',
    );

    this.$header = this.$element.closest('header');
    this.$container = this.$element.closest('.nav__container');
    this.$mainNavToggle = this.$toggles[0];
    this.$mainNavToggleText = this.$mainNavToggle.textContent;
    this.$mainNavToggleClose = 'Close';

    this.$navLinks = this.$element.querySelectorAll('a');

    this.$activeList = null;
    this.$topSubLists = this.$element.querySelectorAll('.nav__list--primary > .nav__item > .nav__subnav');

    this.showMobileSubs = this.$element.dataset['mobileSubs'] === undefined ? false : true;
    this.showDesktopSubs = this.$element.dataset['desktopSubs'] === undefined ? false : true;
    this.hoverNav = this.$element.dataset['hover'] === undefined ? false : true;

    this.observer = this.observerSetup();
  }

  bindEvents() {
    this.bindMediaQuery();
    this.$element.addEventListener('click', this);
    this.$menu.addEventListener('keyup', this);

    if (this.hoverNav) {
      this.$primary.addEventListener('mouseenter', this);
      this.$primary.addEventListener('mouseleave', this);
    }

    this.$back.addEventListener('click', this.backNav.bind(this));

    this.$toggles.forEach(($el) => {
      $el.addEventListener('click', this.toggleNav.bind(this));
      $el.addEventListener('keydown', this.toggleKeys.bind(this));
    });

    this.$pageSections.forEach(($section) => this.observer.observe($section));
  }

  onclick() {
    document.addEventListener('click', this.hideNavOnClickOutside.bind(this));
  }

  onkeyup(e) {
    if (CLOSE_SUBNAV_KEYS.includes(e.key) && this.$activeList) {
      // don't close the main nav if on desktop
      if (!this.isMobile && this.$activeList === this.$menu) return;

      const $parent = this.$activeList.parentElement;
      if ($parent) {
        this.handleNav($parent, 'close', 'all', 'key');

        // return focus to the right place
        $parent.querySelector('[aria-controls]').focus();
      }
    }

    // handle focusout with keyup usage of Tab - close menus when focus leaves
    if (e.key == 'Tab') {
      if (this.$activeList && !this.$activeList.contains(document.activeElement)) {
        // don't close the main nav if on desktop
        if (!this.isMobile && this.$activeList === this.$menu) return;

        this.handleNav(this.$activeList.parentElement, 'close', 'all', 'key');
      }
    }
  }

  onmouseenter() {
    if (!this.isMobile) {
      const setNavHoverClass = function() {
        this.$element.classList.add('has-hover');
      }.bind(this);

      this.hoverTimeout = setTimeout(setNavHoverClass, 300);
    }
  }

  onmouseleave() {
    if (!this.isMobile) {
      clearTimeout(this.hoverTimeout);
      this.$element.classList.remove('has-hover');
    }
  }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // mobile nav query from _nav.scss
    this.mobileMediaQuery = window.matchMedia(rootStyle.getPropertyValue('--mobile-nav-media-query'));

    // listen and set initial
    this.mobileMediaQuery.addEventListener('change', this.onMediaChange.bind(this));
    this.onMediaChange(this.mobileMediaQuery);
  }

  onMediaChange(mobileMediaQuery) {
    this.isMobile = mobileMediaQuery.matches;

    this.positionSubnavs();
    this.reset();
  }

  backNav() {
    this.handleNav(this.$menu, 'close', 'all');
  }

  findThemeClass($el, $backup) {
    let themeClass = false;

    Array.from($el.classList).some((className) => {
      if (className.match(/^theme-/)) {
        themeClass = className;
        return true;
      } else {
        return false;
      }
    });

    if (!themeClass && $backup) {
      themeClass = this.findThemeClass($backup);
    }

    return themeClass ? themeClass : 'theme-light';
  }

  handleNav($el, direction, scope, trigger) {
    if (!$el) return;

    // turn off clicks on desktop items when hovers are on
    if (
      this.hoverNav &&
      !this.isMobile &&
      trigger !== 'key' &&
      $el !== this.$mainNavToggle &&
      !(
        $el === this.$menu &&
        direction === 'close'&&
        scope === 'all'
      )
    ) {
      const href = $el.getAttribute('href');
      const isLink = $el.dataset['jsUrl'] !== undefined;
      if (isLink) {
        return window.location.href = href;
      }

      return;
    }

    const flow = direction || 'toggle';

    let $togglers;
    let $menus;
    let $newActiveList;

    // if scope === all, we'll toggle all menus below this level
    if (scope === 'all') {
      $togglers = $el.querySelectorAll('[aria-controls]');
      $menus = $el.querySelectorAll('[data-js-children="$subLists"]');

      $newActiveList = $el.closest('[data-js-children="$subLists"]');
    } else {
      // if a button or an element
      let $toggler = $el;
      const $parent = $el.parentElement;

      if (!$el.ariaExpanded) {
        $toggler = $el.closest('[data-js-children="$subLists"]').querySelector('[aria-controls]');
      }

      if ($toggler.dataset['controlAllChildren'] === undefined ? false : true) {
        $menus = $parent.querySelectorAll('[data-js-children="$subLists"]');
        $togglers = $parent.querySelectorAll('[aria-controls]');
      } else {
        $menus = [$parent.querySelector(`#${$toggler.getAttribute('aria-controls')}`)];
        $togglers = [$toggler];
      }

      // if closing a single menu, also close everything below this level
      if (flow === 'close' || (flow === 'toggle' && $toggler.ariaExpanded === 'true')) {
        this.handleNav($menus[0], 'close', 'all');
        $newActiveList = $menus[0].closest('[data-js-children="$subLists"]');
      } else {
        $newActiveList = $menus[0];

        // if opening a single menu, close any other open menus
        if (this.$activeList && $newActiveList !== this.$activeList && !this.$activeList.contains($newActiveList)) {
          // if parents of activelist and newactivelist are the same, close activelist
          // if not, we have to find the sibling to newactive list that is open and close it
          const $otherMenu =
            this.$activeList.parentElement.parentElement === $newActiveList.parentElement.parentElement ?
              this.$activeList.parentElement.querySelector(`[aria-controls='${this.$activeList.id}']`) :
              $newActiveList.parentElement.parentElement.querySelector('[aria-expanded="true"]');
          this.handleNav($otherMenu, 'close');
        }

        // update the indicator
        this.$indicator.textContent = $el.innerText;
      }
    }

    $togglers.forEach(($toggler) => {
      this.handleNavToggler($toggler, flow);
    });

    $menus.forEach(($menu) => {
      this.handleMenuToggle($menu, flow);
    });

    this.$activeList = $newActiveList;
  }

  handleMenuToggle($menu, direction) {
    if (!$menu) return;

    // don't change menu for subnavs if sub menus are supposed to always be showing
    if ($menu.matches('.nav__subnav-lists *') && ((this.showMobileSubs && this.isMobile) || (this.showDesktopSubs && !this.isMobile))) return;

    const hiddenValues = {
      open: false,
      close: true,
      toggle: $menu.hidden !== true,
    };

    // toggle hidden attribute
    $menu.hidden = hiddenValues[direction];

    // change mobile nav toggle text
    if ($menu.matches('#menu')) {
      const mobileMenuText = {
        open: this.$mainNavToggleClose,
        close: this.$mainNavToggleText,
        toggle: this.$mainNavToggle.textContent === this.$mainNavToggleText ? this.$mainNavToggleClose : this.$mainNavToggleText,
      };

      this.$mainNavToggle.textContent = mobileMenuText[direction];
    }
  }

  handleNavToggler($toggle, direction) {
    if (!$toggle) return;

    // don't change toggle for subnavs if sub menus are supposed to always be showing
    if ($toggle.matches('#navigation li li [aria-expanded]') && ((this.showMobileSubs && this.isMobile) || (this.showDesktopSubs && !this.isMobile))) return;

    const ariaExpandedValues = {
      open: 'true',
      close: 'false',
      toggle: $toggle.ariaExpanded !== 'true',
    };

    // toggle aria-expanded
    $toggle.ariaExpanded = ariaExpandedValues[direction];
  }

  hideNavOnClickOutside(e) {
    if (!this.$element.contains(e.target)) {
      this.handleNav(this.$menu, 'close', 'all');
      document.removeEventListener('click', this.hideNavOnClickOutside);
    }
  }

  observerSetup() {
    return new IntersectionObserver(
      ($entries) => {
        $entries.forEach(($entry) => {
          if ($entry.isIntersecting && $entry.boundingClientRect.top <= 0) {
            const newTheme = this.findThemeClass($entry.target, document.body);
            const oldTheme = this.findThemeClass(this.$header, document.body);

            if (newTheme !== oldTheme) {
              const classList = this.$header.classList;
              classList.remove(oldTheme);
              classList.add(newTheme);
            }
          }
        });
      },
      {
        rootMargin: '0px 0px -100% 0px', // Trigger when the top of the section reaches the top of the viewport
        threshold: 0,
      },
    );
  }

  positionSubnavs() {
    if (!this.isMobile) {
      const containerLeft = this.$container.offsetLeft;
      const containerRight = containerLeft + this.$container.offsetWidth;

      this.$topSubLists.forEach(($list) => {
        const navParentLeft = containerLeft + $list.parentElement.offsetLeft;

        if ((navParentLeft + $list.offsetWidth) > containerRight) {
          $list.classList.add('nav__subnav--overflows');
        } else {
          $list.classList.remove('nav__subnav--overflows');
        }
      });
    }
  }

  reset() {
    this.handleNav(this.$menu, 'close', 'all');

    if (this.isMobile) {
      this.handleNav(this.$mainNavToggle, 'close');
      this.resetSubLists('mobile');
    } else {
      this.handleNav(this.$mainNavToggle, 'open');
      this.resetSubLists('desktop');
    }
  }

  resetSubLists(scope) {
    if (!this.$subLists) return;

    if (scope === 'mobile') {
      if (this.showMobileSubs) {
        this.$subLists.forEach(($list) => {
          // only automatically open sublists that aren't the first level
          // have to walk up way too far. there is a better way to do this
          if ($list.parentElement.parentElement.parentElement !== this.$menu ) {
            $list.hidden = false;
            $list.parentElement.querySelector(`[aria-controls="${$list.id}"]`).ariaExpanded = 'true';
          }
        });
      } else {
        this.$subLists.forEach(($list) => {
          $list.hidden = true;
          $list.parentElement.querySelector(`[aria-controls="${$list.id}"]`).ariaExpanded = 'false';
        });
      }
    } else {
      if (this.showDesktopSubs) {
        this.$subLists.forEach(($list) => {
          // only automatically open sublists that aren't the first level
          // have to walk up way too far. there is a better way to do this
          if ($list.parentElement.parentElement.parentElement !== this.$menu ) {
            $list.hidden = false;
            $list.parentElement.querySelector(`[aria-controls="${$list.id}"]`).ariaExpanded = 'true';
          }
        });
      } else {
        this.$subLists.forEach(($list) => {
          $list.hidden = true;
          $list.parentElement.querySelector(`[aria-controls="${$list.id}"]`).ariaExpanded = 'false';
        });
      }
    }
  }

  toggleKeys(e) {
    if (e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (TOGGLE_SUBNAV_KEYS.includes(e.key)) {
      this.toggleNav.call(this, e);
    }
  }

  toggleNav(e) {
    e.preventDefault();

    const $el = e.currentTarget;

    // don't toggle the nav if this is a toggle for a shown by default sub nav
    if ($el.matches('#navigation li li [aria-expanded]') && ((this.showMobileSubs && this.isMobile) || (this.showDesktopSubs && !this.isMobile))) return;

    this.handleNav($el, 'toggle', '', e.type === 'keydown' ? 'key' : 'click');
  }


  unmount() {
    this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
    this.$element.removeEventListener('click', this);
    document.removeEventListener('click', this.hideNavOnClickOutside);
    this.$menu.removeEventListener('keyup', this);

    if (this.hoverNav) {
      this.$primary.removeEventListener('mouseenter', this);
      this.$primary.removeEventListener('mouseleave', this);
    }

    this.$back.removeEventListener('click', this.backNav);

    this.$toggles.forEach(($el) => {
      $el.removeEventListener('click', this.toggleNav);
      $el.removeEventListener('keyup', this.toggleKeys);
    });

    this.$navLinks.forEach(($el) => {
      $el.removeEventListener('focusout', this);
    });

    this.$pageSections.forEach(($section) => this.observer.unobserve($section));
  }
}

registerModule('Nav', Nav);
